import { useRef } from 'react'
import { validateEmail } from '../../lib/formatters'

function CheckIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 7.5L6 10L11 4" />
    </svg>
  )
}

function computeGhostSuffix(value, domain) {
  if (!domain || !value) return ''
  const atIdx = value.indexOf('@')
  if (atIdx < 0) return ''
  const typedDomain = value.slice(atIdx + 1)
  const d = domain.toLowerCase()
  const t = typedDomain.toLowerCase()
  if (t === '') return domain
  if (d.startsWith(t)) return domain.slice(typedDomain.length)
  return ''
}

export default function EmailInputWithDomain({
  value,
  onChange,
  suggestedDomain,
  error,
  readOnly,
  className,
  ...rest
}) {
  const inputRef = useRef(null)
  const v = value || ''
  const { isValid } = validateEmail(v)
  const ghost = computeGhostSuffix(v, suggestedDomain)

  const baseCls =
    'row-input' +
    (error ? ' has-error' : '') +
    (readOnly ? ' is-readonly' : '') +
    (className ? ' ' + className : '')

  const acceptGhost = () => {
    if (!ghost || !onChange) return
    onChange(v + ghost)
  }

  const handleKeyDown = (e) => {
    if (!ghost) return
    if (e.key === 'Tab') {
      e.preventDefault()
      acceptGhost()
      return
    }
    if (e.key === 'ArrowRight') {
      const el = inputRef.current
      if (el && el.selectionStart === v.length && el.selectionEnd === v.length) {
        e.preventDefault()
        acceptGhost()
      }
    }
  }

  return (
    <span className="row-input-wrap">
      {ghost && (
        <span className="row-input-ghost" aria-hidden="true">
          <span className="row-input-ghost-typed">{v}</span>
          <span className="row-input-ghost-suffix">{ghost}</span>
        </span>
      )}
      <input
        ref={inputRef}
        type="email"
        inputMode="email"
        className={baseCls}
        value={v}
        onChange={(e) => onChange && onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        readOnly={readOnly}
        data-lpignore="true"
        data-form-type="other"
        {...rest}
      />
      {isValid && (
        <span className="row-input-suffix">
          <CheckIcon />
        </span>
      )}
    </span>
  )
}
